import PropTypes from 'prop-types';
import React from 'react';

import { ReactComponent as ArrowDown } from '../../images/icons/arrowDown.svg';
import { ReactComponent as Arrow } from '../../images/icons/fs-lc-arrow.svg';
import * as s from './Links.module.css';
import SmartLink from './SmartLink';

const ArrowLink = ({
  inheritColor,
  url,
  isDownload,
  label,
  onClick,
  className = '',
  isLarge,
  isArrowDown,
  isArrowUp,
  isExternal,
  hoverAnimation = false,
}) => {
  const classes = [
    isLarge ? s.arrowLinkLarge : s.arrowLink,
    className,
    'cta',
    hoverAnimation ? s.bounceArrow : '',
    inheritColor ? s.inheritColor : '',
  ].join(' ');
  let arrowDirection = <Arrow className={s.arrow} />;
  if (isArrowDown) {
    arrowDirection = <ArrowDown className={s.arrow} />;
  } else if (isArrowUp) {
    arrowDirection = <Arrow className={[s.arrow, s.arrowUp].join(' ')} />;
  }

  return (
    <SmartLink to={url} onClick={onClick} className={classes} download={isDownload} isExternal={isExternal}>
      <span>
        {label}
        {arrowDirection}
      </span>
    </SmartLink>
  );
};

const PrimaryLink = ({ url, onClick, label, isButton, backgroundColor, expand, className = '', id = '' }) => {
  let buttonClass = backgroundColor === 'white' ? s.secondaryButton : s.primaryButton;
  if (backgroundColor === 'pink') {
    buttonClass = s.pinkButton;
  }
  if (expand) {
    buttonClass = `${buttonClass} ${s.expand}`;
  }
  const classes = [isButton ? buttonClass : s.primaryLink, className, 'cta'].join(' ');

  return (
    <SmartLink to={url} onClick={onClick} id={id} className={classes}>
      {label}
    </SmartLink>
  );
};

const sharedProps = {
  url: PropTypes.string,
  label: PropTypes.string.isRequired,
};

ArrowLink.defaultProps = {
  isLarge: false,
  isArrowDown: false,
  isArrowUp: false,
  isExternal: false,
};

ArrowLink.propTypes = {
  isLarge: PropTypes.bool,
  isArrowDown: PropTypes.bool,
  isArrowUp: PropTypes.bool,
  isExternal: PropTypes.bool,
  ...sharedProps,
};

PrimaryLink.defaultProps = {
  isButton: false,
};

PrimaryLink.propTypes = {
  isButton: PropTypes.bool,
  id: PropTypes.string,
  ...sharedProps,
};

export { ArrowLink, PrimaryLink };
